<div>
  <label>User password</label>
  @if (product.password.enabled) {
    <span>Required</span>
  }
  @if (!product.password.enabled) {
    <span>Not required</span>
  }
  <hr />
</div>
